<template>
  <transition name="fade">
    <div class="pin w-full h-screen flex">
      <div class="justify-center p-8 bg-white w-full flex flex-col">
        <p class="text-center">
          <clip-loader color="#ee6f56"></clip-loader>
        </p>
      </div>
    </div>
  </transition>
</template>
<script>
import ClipLoader from 'vue-spinner/src/PulseLoader.vue';

export default {
  components: {
    ClipLoader,
  },
};
</script>
